import { formatDateForSchedule } from '../../../utils/formatDate';
import { isDefined } from '../../../utils/isDefined';
import Optional from '../../../utils/optional';
import filterSubs from './filterSubs';

const mapDataForExport = ({ subscriptions, lang, filters }) => {
  const filteredSubs = filterSubs({ subscriptions, lang, filters });
  return filteredSubs.map(subscription => {
    const { translations } = subscription;
    const skuTranslation = isDefined(translations?.sku)
      ? Optional(translations.sku[lang]).or(translations.sku['default'])
      : '';

    return {
      ...subscription,
      skuTranslation,
      activationDate: Optional(
        formatDateForSchedule(subscription.activationDate)
      ).or('-'),
      expiryDate: Optional(formatDateForSchedule(subscription.expiryDate)).or(
        '-'
      )
    };
  });
};

export default mapDataForExport;
